import { render, staticRenderFns } from "./editar.vue?vue&type=template&id=b6a9a248&scoped=true&"
import script from "./editar.vue?vue&type=script&lang=ts&"
export * from "./editar.vue?vue&type=script&lang=ts&"
import style0 from "./editar.vue?vue&type=style&index=0&id=b6a9a248&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a9a248",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDivider,VRow,VTextField})
